



































































import Vue from "vue";
import swatchesWrapper from '@/components/Swatches/SwatchesWrapper';
import { PickYourOwnColorStoreState } from "@/store/modules/pickYourOwnColor/pickYourOwnColor.t";
import { ISwatch } from "@/store/modules/swatches/swatches.t";

export interface IYourColorsData {
  yourcolors: IYourColors 
}

export interface IYourColors {
  display_name: string
  name: string
  order: number
  swatches: ISwatch[] 
}

export default Vue.extend({
  name: "pickYourOwnColorTray",
  components: {
    swatchesWrapper,
  },
  data() {
    return {
      activeGroup: "",
    }
  },
  computed: {
    pickYourOwnColor(): PickYourOwnColorStoreState {
      return this.$store.state.pickYourOwnColor
    },
    isOpen(): boolean {
      return this.pickYourOwnColor.isOpen
    },
    isMobile(): boolean {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    yourColorsData(): IYourColorsData {
      return {
        yourcolors: {
          display_name: "Your Colors",
          name: "yourcolors",
          order: 1,
          swatches: this.pickYourOwnColor.swatches,
        },
      };
    },
  },
  methods: {
    changeVisibleGroup(groupName: string) {
      this.activeGroup = groupName;
    },
    onToggleColorPicker(): void {
      this.$store.commit("pickYourOwnColor/SET_OPEN_COLOR_PICKER", !this.isOpen)
    },
  },
  created() {
    this.$eventBus.$on("changeVisibleGroup", this.changeVisibleGroup);
  },
  beforeDestroy() {
    this.$eventBus.$off("changeVisibleGroup", this.changeVisibleGroup);
  },
})

